var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file inputNumber组件
 * @author (wangzichuan)
 */

/* global document */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash-es';
import classnames from 'classnames';
import { classPrefix } from '../../common/util';

import './InputNumber.less';
/**
 * 参数说明
 * className               可选，自定义class
 * classPrefix             可选，自定义前缀，默认'spui'
 * value                   可选，input的值
 * name                    可选，组件name
 * getValue                可选，组件变化时回调函数
 * max                     可选，最大值
 * min                     可选，最小值
 * disable                 可选，禁用状态
 * readOnly                可选，只读状态
 * star                    可选，是否必填的*号
 * tips                    可选，后面的说明文字
 * step                    可选，加减的步长，默认为1
 */

var InputNumber = function (_Component) {
    _inherits(InputNumber, _Component);

    function InputNumber(props) {
        _classCallCheck(this, InputNumber);

        var _this = _possibleConstructorReturn(this, (InputNumber.__proto__ || Object.getPrototypeOf(InputNumber)).call(this, props));

        _this.reduceClick = function () {
            var _this$props = _this.props,
                disable = _this$props.disable,
                min = _this$props.min,
                step = _this$props.step,
                value = _this$props.value;

            if (disable) {
                return;
            }
            if (min !== undefined && min >= value) {
                return;
            }
            var newNumber = value - step;
            _this.valueChange(newNumber);
        };

        _this.addClick = function () {
            var _this$props2 = _this.props,
                disable = _this$props2.disable,
                max = _this$props2.max,
                step = _this$props2.step,
                value = _this$props2.value;

            if (disable) {
                return;
            }
            if (max !== undefined && max <= value) {
                return;
            }
            var newNumber = value + step;
            _this.valueChange(newNumber);
        };

        _this.inputOnChange = function (e) {
            var _this$props3 = _this.props,
                max = _this$props3.max,
                min = _this$props3.min;

            var newNumber = parseFloat(e.target.value) || 0;
            if (max !== undefined && max <= newNumber) {
                newNumber = max;
            }
            if (min !== undefined && min >= newNumber) {
                newNumber = min;
            }
            _this.valueChange(newNumber);
        };

        _this.inputOnClick = function () {
            _this.setState({ inputfocus: true });
        };

        _this.valueChange = function (value) {
            var _this$props4 = _this.props,
                getValue = _this$props4.getValue,
                name = _this$props4.name;

            _.isFunction(getValue) && getValue({
                name: name,
                value: value
            });
        };

        _this.bodyClick = function (e) {
            if (e.target === _this.input) {
                return;
            }
            _this.setState({ inputfocus: false });
        };

        _this.FORM_NEED_VALIDATE = 0;
        _this.FORM_NO_NEED_VALIDATE = 1;
        _this.state = {
            inputfocus: false
        };
        _this.formCallback(props.value, _this.FORM_NO_NEED_VALIDATE);
        return _this;
    }

    _createClass(InputNumber, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(np) {
            if (!_.isEqual(np.value, this.props.value)) {
                this.formCallback(np.value, this.FORM_NEED_VALIDATE);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.body.addEventListener('click', this.bodyClick);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.formCallback(this.props.value, this.FORM_NO_NEED_VALIDATE, true);

            document.body.removeEventListener('click', this.bodyClick);
        }
    }, {
        key: 'formCallback',
        value: function formCallback(data, type, isDelete) {
            var _props = this.props,
                increment = _props.increment,
                name = _props.name,
                onHandleChange = _props.onHandleChange;


            if (onHandleChange && _.isFunction(onHandleChange)) {
                onHandleChange({
                    name: name,
                    value: data
                }, this, type, increment, isDelete);
            }
        }
        // inputOnBlur = () => {
        //     this.formCallback(this.state.number, this.FORM_NEED_VALIDATE);
        // }

    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _this2 = this;

            var _props2 = this.props,
                className = _props2.className,
                classPrefix = _props2.classPrefix,
                validate = _props2.validate,
                label = _props2.label,
                tips = _props2.tips,
                star = _props2.star,
                min = _props2.min,
                max = _props2.max,
                disable = _props2.disable,
                readOnly = _props2.readOnly,
                value = _props2.value;

            var rootCls = classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-input-number-wrap', true), _defineProperty(_classnames, className, !!className), _classnames));
            var mainDiv = classnames({
                'input-main-div': true,
                'input-number-focus': this.state.inputfocus,
                'input-number-disable': disable || readOnly,
                'input-number-warning': validate && validate.ret !== 0
            });
            var reduceCls = classnames({
                'input-number-reduce': true,
                'input-number-reduce-min': min !== undefined && value <= min,
                'input-number-reduce-disable': disable || readOnly,
                'input-number-reduce-readOnly': readOnly
            });
            var inputCls = classnames({
                'input-number-input': true,
                'input-number-input-disable': disable || readOnly
            });
            var addCls = classnames({
                'input-number-add': true,
                'input-number-add-max': max !== undefined && value >= max,
                'input-number-add-disable': disable || readOnly,
                'input-number-add-readOnly': readOnly
            });
            var warnCls = classnames({
                'input-warn-div': true,
                'padding-left-170': !!label
            });
            return React.createElement(
                'div',
                { className: rootCls },
                label && React.createElement(
                    'div',
                    { className: classPrefix + '-form-label' },
                    label
                ),
                React.createElement(
                    'div',
                    { className: mainDiv },
                    React.createElement('div', { className: reduceCls, onClick: this.reduceClick }),
                    React.createElement('input', {
                        ref: function ref(el) {
                            return _this2.input = el;
                        },
                        className: inputCls,
                        type: 'number',
                        value: this.props.value,
                        onChange: this.inputOnChange,
                        onClick: this.inputOnClick,
                        onBlur: this.inputOnBlur,
                        disabled: disable || readOnly
                    }),
                    React.createElement('div', { className: addCls, onClick: this.addClick })
                ),
                star && React.createElement(
                    'span',
                    { className: classPrefix + '-input-star' },
                    '*'
                ),
                tips && React.createElement(
                    'span',
                    { className: classPrefix + '-input-tips' },
                    tips
                ),
                React.createElement(
                    'div',
                    { className: warnCls },
                    validate && validate.message && React.createElement(
                        'span',
                        null,
                        React.createElement('i', { className: classPrefix + '-input-error' }),
                        validate.message
                    )
                )
            );
        }
    }]);

    return InputNumber;
}(Component);

InputNumber.propTypes = {
    className: PropTypes.string,
    classPrefix: PropTypes.string,
    validate: PropTypes.object,
    value: PropTypes.number,
    onHandleChange: PropTypes.func,
    name: PropTypes.string,
    increment: PropTypes.string,
    getValue: PropTypes.func,
    label: PropTypes.node,
    star: PropTypes.bool,
    tips: PropTypes.node,
    max: PropTypes.number,
    min: PropTypes.number,
    disable: PropTypes.bool,
    readOnly: PropTypes.bool,
    step: PropTypes.number
};
InputNumber.defaultProps = {
    classPrefix: classPrefix,
    value: 0,
    step: 1
};
export default InputNumber;